import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import CtaButton from '../buttons/cta-button'
import HeadingBeta from '../headings/heading-beta'
import HeadingDelta from '../headings/heading-delta'
import Icon from '../icons/icon'
import NormalText from '../texts/normal-text'
import InfoBlock from '../texts/info-block'

const propTypes = {
  heroText: PropTypes.string,
  subText: PropTypes.string,
  createEventText: PropTypes.string,
  createEventButtonLabel: PropTypes.string,
  skipNowText: PropTypes.string,
  goHomeButtonLabel: PropTypes.string,
  onCreateEventButtonClick: PropTypes.func
}

const defaultProps = {
  heroText: 'Hooray!',
  subText: 'You have successfully register your charity. Welcome aboard!',
  createEventText: 'Do you want to create an event now?',
  createEventButtonLabel: 'Create my first Event',
  skipNowText:
    'You can go to MyCharity at any time from your User Menu on top right.',
  goHomeButtonLabel: 'Go to home'
}

const RegisterCharityConfirmation = props => (
  <div>
    <InfoBlock className='top-space'>
      <HeadingBeta thin center>
        {props.heroText}
      </HeadingBeta>
      <HeadingDelta thin center>
        {props.subText}
      </HeadingDelta>
    </InfoBlock>
    <div className='top-space bottom-space center'>
      <Icon name='finished-event' className='prominent-icon' />
    </div>
    <NormalText center>{props.createEventText}</NormalText>
    <div className='top-space bottom-space-sm center'>
      <CtaButton
        hasIcon
        text={props.createEventButtonLabel}
        iconName='fundrising-events'
        onClick={props.onCreateEventClick}
      />
    </div>
    <div className='top-space bottom-space'>
      <NormalText center>
        {props.skipNowText}
        <Link to='/explore' className='single-link block'>
          {props.goHomeButtonLabel}
        </Link>
      </NormalText>
    </div>
  </div>
)

RegisterCharityConfirmation.propTypes = propTypes
RegisterCharityConfirmation.defaultProps = defaultProps

export default RegisterCharityConfirmation



// WEBPACK FOOTER //
// ./src/ui/views/register-charity-confirmation.js